import { Tag } from 'react-aria-components';
import styled from 'styled-components';

export const DiscountTag = styled(Tag)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
  width: fit-content;
  padding: var(--spacing-small);
  background: var(--grey-50);
  border-radius: var(--radius-base);

  & svg {
    width: 18px;

    &:is(button &) {
      width: 14px;
    }

    &:not(:is(button &)) {
      transform: scaleX(-1);
    }

    & path {
      stroke: var(--grey-600);
    }
  }

  & button {
    display: flex;
    background: transparent;
    border: none;
  }

`;
